import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useU2000AxiosAuthenticated from '../u2000Core/axios/U2000UseAxiosAuthenticated';
import { U2000HandleApiError } from '../u2000Core/axios/U2000HandleApiError';
import { useToast } from '../u2000Core/context/toast/U2000ToastContext';
import { doDay, luHandleApiError, type U3147DayResult } from './U3147Service';
import { NS } from './U3147';

export function useU3147DayHandlers() {
  const axios = useU2000AxiosAuthenticated();
  const { t } = useTranslation();
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [dayResult, setDayResult] = useState<U3147DayResult | null>(null);

  const loadDay = useCallback(
    async (date: string, employeeId?: string) => {
      setLoading(true);
      try {
        const response = await doDay(axios, { date: date.slice(0, 10), ...(employeeId?.trim() ? { employeeId } : {}) });
        const raw = response.data?.result ?? response.data;
        setDayResult(raw as U3147DayResult);
        return raw as U3147DayResult;
      } catch (error: unknown) {
        const errorResult = U2000HandleApiError(error as Error, t, NS, luHandleApiError);
        if (errorResult.genericErrors?.length) {
          errorResult.genericErrors.forEach((err) => toast.error(err.text, err.title));
        }
        setDayResult(null);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [axios, t, toast],
  );

  return { loading, dayResult, setDayResult, loadDay };
}
